import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled, { createGlobalStyle } from 'styled-components';

class Banner extends Component {
  constructor(props) {
    super(props);
    this.banner = React.createRef();
  }

  state = {
    active: false
  };

  updateHeight = () => {
    document.querySelector('body').style.marginTop =
      this.banner.current.clientHeight + 'px';
  };

  componentDidMount() {
    this.setState({ active: true }, this.updateHeight);
    document.querySelector('body').classList.add('has-banner');
    window.addEventListener('resize', this.updateHeight);
  }

  componentWillUnmount() {
    document.querySelector('body').style.marginTop = 0;
    document.querySelector('body').classList.remove('has-banner');
    window.removeEventListener('resize', this.updateHeight);
  }

  render() {
    const { className, children } = this.props;
    return (
      <Fragment>
        <BodyWithBanner />
        <Aside
          className={classnames(
            'text-left text-lg-center p-3 small',
            { active: this.state.active },
            className
          )}
          ref={this.banner}>
          {children}
        </Aside>
      </Fragment>
    );
  }
}

export default Banner;

Banner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

const Aside = styled.aside`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  z-index: 1010;
  transform: translateY(-100%);
  text-align: center;
  &.active {
    box-shadow: 0 0px 1px #000;
    transform: translateY(0);
  }
`;

const BodyWithBanner = createGlobalStyle`
  body.has-banner {
    transition: margin-top 500ms cubic-bezier(0.694, 0.0482, 0.335, 1);
  }
`;
